define( [ 'utility', 'vendor/detect-element-resize' ], function run( utility ) {
	'use strict';

	var uScrollableFn = {
		init : function( elm ) {
			var axisType = 'yx',
				elmData,
				scrollAreaContentWrapper,
				scrollAreaContentInner,
				checkScrollable;

			if ( !elm.classList.contains( 'js-u-scrollable' ) ) {
				elm.classList.add( 'js-u-scrollable' );

				elm.uScrollable = {}; // Setup uScrollable object
				elm.removeAttribute( 'tabindex' );

				elmData = utility.getData( elm );
				scrollAreaContentWrapper = document.createElement( 'div' );
				scrollAreaContentInner = document.createElement( 'div' );
				utility.wrapInner( elm, scrollAreaContentWrapper, 'scrollable-content-wrapper' );
				utility.wrapInner( scrollAreaContentWrapper, scrollAreaContentInner, 'scrollable-content-wrapper__inner' );
				elm.append( utility.htmlStringToElement( '<div class="u-scrollable__ui"></div>' ) );

				if ( elm.classList.contains( 'm-table' ) ) {
					axisType = 'x';
				} else if ( elm.classList.contains( 'o-modal__content-holder' ) ) {
					axisType = 'y';
				} else if ( typeof elmData.axis === 'string' ) {
					axisType = elmData.axis;
				} else {
					// Do nothing
				}

				checkScrollable = utility.debounce( function debounceFunc() {
					elm.classList.remove( 'is-scrollable' );
					elm.classList.remove( 'is-scrollable--x' );
					elm.classList.remove( 'is-scrollable--y' );

					if ( utility.isOverflown( elm, axisType ) ) {
						elm.classList.add( 'is-scrollable' );
						if ( axisType === 'x' ) {
							elm.classList.add( 'is-scrollable--x' );
						} else if ( axisType === 'y' ) {
							elm.classList.add( 'is-scrollable--y' );
						}
						elm.firstChild.setAttribute( 'tabindex', 0 );
					} else {
						elm.firstChild.removeAttribute( 'tabindex' );
					}
				}, 10 );

				// Use native resizeObserver when available
				if ( 'ResizeObserver' in window ) {
					const ro = new ResizeObserver( entries => entries.forEach( () => checkScrollable() ) );
					ro.observe( elm );
				} else {
					// Legacy IE11 version (REMOVE V6 and detect-element-resize)
					window.addResizeListener( scrollAreaContentInner, checkScrollable );
				}
				window.addEventListener( 'refresh', checkScrollable );

				checkScrollable();
			}

			return elm.uScrollable;
		},
	};

	return {
		initInstance : function( elm ) {
			return uScrollableFn.init( elm );
		},
	};
});
